import api from './api';

// Get all posts
export const getPosts = async () => {
  const response = await api.get('/posts/me');
  return response.data;
};

// Get a single post by ID
export const getPostById = async (postId, isPreviewMode = false) => {
  const url = isPreviewMode
    ? `/posts/${postId}?preview=true`
    : `/posts/${postId}`;
  const { data } = await api.get(url);
  return data;
};

// Create a new post

export const createPost = async (postData) => {
  // --- MODIFICACIÓN ---
  // Ya no se espera FormData, sino un objeto JSON con los metadatos del post.
  if (postData instanceof FormData) {
    throw new Error(
      'createPost obsoleto. La subida de FormData ya no se maneja aquí.'
    );
  }
  // La llamada a la API ahora envía JSON
  const response = await api.post('/posts', postData);
  return response.data;
};

// Update an existing post
export const updatePost = async (postId, postData) => {
  // --- MODIFICACIÓN ---
  // Ya no se espera FormData. Se envía JSON con los metadatos.
  if (postData instanceof FormData) {
    throw new Error(
      'updatePost obsoleto. La subida de FormData ya no se maneja aquí.'
    );
  }
  // Se elimina onUploadProgress ya que no hay subida de archivos aquí.
  const response = await api.put(`/posts/${postId}`, postData);
  return response.data;
};

// Delete a post
export const deletePost = async (postId) => {
  const response = await api.delete(`/posts/${postId}`);
  return response.data;
};

// Like a post
export const likePost = async (postId) => {
  const response = await api.post(`/posts/${postId}/like`);
  return response.data;
};

// Unlike a post
export const unlikePost = async (postId) => {
  const response = await api.delete(`/posts/${postId}/like`);
  return response.data;
};

export const getAvailableEffects = async () => {
  const response = await api.get('/posts/effects/available');
  return response.data;
};

export const updatePostPremiumSettings = async (postId, settingsData) => {
  const response = await api.put(`/posts/${postId}/premium`, settingsData);
  return response.data;
};

export const changePostEffect = async (postId, effectType, effectIntensity) => {
  const response = await api.put(`/posts/${postId}/effect`, {
    effectType,
    effectIntensity,
  });
  return response.data;
};

export const checkPostAccess = async (postId) => {
  const response = await api.get(`/posts/${postId}/access`);
  return response.data;
};

export const getPublicPostsByUsername = async (username) => {
  const response = await api.get(`/posts/user/${username}`);
  return response.data;
};

export const getEffectPreview = async (formData) => {
  const { data } = await api.post('/media/preview-effect', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getPostPrice = async (postId) => {
  const { data } = await api.get(`/posts/${postId}/price`);
  return data;
};
export const removeCustomCover = async (postId) => {
  const response = await api.delete(`/posts/${postId}/custom-cover`);
  return response.data;
};
export const reportPost = async (postId, reason) => {
  const response = await api.post(`/posts/${postId}/report`, { reason });
  return response.data;
};
